module.exports = __webpack_public_path__ + "img/67.06243a22.jpg";